import { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import { cartState } from "atoms";
import Modal from "react-bootstrap/Modal";
import { useLocation } from "react-router-dom";
import { PATH } from "utils/const";

const RateChangeBanner = () => {
  const [rateChangeDismissed, setRateChangeDismissed] = useState<any>(false);
  const [showRateChangeModal, setShowRateChangeModal] = useState(false);
  const cart = useRecoilValue(cartState);
  const location = useLocation();

  useEffect(() => {
    const dismissedRateChangeBannerValue: any = sessionStorage.getItem("dismissedRateChangeBanner") ? true : false;
    setRateChangeDismissed(dismissedRateChangeBannerValue);
  }, []);

  return (
    <>
      {cart?.showRateChangeBanner && !rateChangeDismissed && (location.pathname === PATH.BROWSE || location.pathname === PATH.CUSTOMER_SUMMARY) ? (
        <div className="rate-increase-banner-container">
          <div className="container">
            <div className="rate-increase-banner-content">
              <h2>NOTICE</h2>
              <p>
                On February 1, 2025, rates of some of our plans and fees will be increasing. As a result, the price you see on your first bill may be
                higher than what is currently reflected on the website.
              </p>
              <span className="click-more-info" onClick={() => setShowRateChangeModal(true)} style={{ color: "#f2a900" }}>
                CLICK TO VIEW MORE INFORMATION <i className="fa-light fa-chevrons-right"></i>
              </span>
            </div>
            <div
              className="rate-increase-banner-close"
              onClick={() => {
                sessionStorage.setItem("dismissedRateChangeBanner", "true");
                setRateChangeDismissed(true);
              }}
            >
              X
            </div>
          </div>
          <Modal show={showRateChangeModal} onHide={() => setShowRateChangeModal(false)} size="lg">
            <Modal.Header closeButton>
              <Modal.Title>
                <h1 className="mt-2">RATES INCREASE</h1>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div>
                <p style={{ marginBottom: "20px" }}>
                  TV rates are increased to help offset higher fees imposed by programmers. The Local Station Charge is set by the TV broadcasters and
                  is a pass-through charge. Comporium does not retain any portion of this charge. Please visit&nbsp;
                  <span
                    style={{ textDecoration: "underline", cursor: "pointer", color: "#337ab7" }}
                    onClick={() => window.open("https://tvonmyside.com/", "_blank")}
                  >
                    tvonmyside.com/comporium
                  </span>{" "}
                  for additional information about how programmers’ fees affect your bill and how providers like Comporium are working to keep rates
                  reasonable. Increases on some tiers of internet helps to offset the cost of recent upgrades to our system, internet speed increases,
                  and support the continued work to improve our network’s reliability.
                  <p>
                    <strong>Note: </strong>Some price point bundles will be impacted by these increases.
                  </p>
                </p>
              </div>
              <div className="table-responsive">
                <table className="table table-striped">
                  <thead style={{ backgroundColor: "#D9EDF7" }}>
                    <tr>
                      <th>Service</th>
                      <th>All Plans</th>
                      <th>Area</th>
                      <th>Increase Amount (1/29/25)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <strong>TV</strong>
                      </td>
                      <td>Basic Plus Plan</td>
                      <td>All Areas</td>
                      <td>$4.00</td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>Broadcast Station Fee-Brevard</td>
                      <td>Transylvania County</td>
                      <td>$3.91</td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>Broadcast Station Fee-Midlands</td>
                      <td>Aiken, Calhoun, Orangeburg, Lexington, Edgefield, Saluda and Richland Counties</td>
                      <td>$2.65</td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>Broadcast Station Fee-Chesnee</td>
                      <td>Chesnee Area</td>
                      <td>$3.91</td>
                    </tr>
                    <tr>
                      <td>
                        <strong>PHONE</strong>
                      </td>
                      <td>Residential Access Line</td>
                      <td>York, Lancaster, and Transylvania Counties</td>
                      <td>$0.53</td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>Voice Plus (Res only)</td>
                      <td>All Areas</td>
                      <td>$1.00</td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>Voice Plus Unlimited (Res only)</td>
                      <td>All Areas</td>
                      <td>$1.00</td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>Business Access Line</td>
                      <td>All Areas</td>
                      <td>$0.82</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </Modal.Body>
          </Modal>
        </div>
      ) : null}
    </>
  );
};

export default RateChangeBanner;
